import type { SquawkPagesParams } from "@common/api/quoting/squawk"
import type { LinkOptions } from "@tanstack/react-router"
import { createContext, useContext } from "react"
import type { SquawkOptionsParams, SquawksSearch } from "../-lib/search"

export type SquawkList = {
  search: SquawksSearch
  params: SquawkPagesParams
  options: SquawkOptionsParams
  open: (squawkId: string) => LinkOptions
  close: LinkOptions
}

export const SquawkListContext = createContext<SquawkList | null>(null)

export function useSquawkList(): SquawkList {
  const context = useContext(SquawkListContext)
  if (context === null) {
    throw new Error("useSquawkList requires SquawkListContext")
  }
  return context
}
